// Public surface for @symbo.ls/collab-features/chat. Import from here
// — internals may rearrange as more of the intranet's chat logic
// migrates into the package.

export { CHAT_CONFIG } from './config.js'
export { chatClient, chatAvailable } from './client.js'
export {
  listChannels,
  listMessages,
  sendMessage,
  deleteMessage,
  channelDisplayName,
  subscribeMessages,
  unreadCount
} from './queries.js'

// UI surface — ChatDrawer + helpers usable in any DOMQL app that has
// governance federation (intranet, editor, admin). Component is
// registered once by the consumer's app-level `components/index.js`
// re-export; state is keyed on `root._chatDrawer*`.
export {
  ChatDrawer,
  ChatDrawerChannelRow,
  ChatDrawerMessage,
  toggleChatDrawer,
  openChatDrawer,
  closeChatDrawer,
  bootstrapChatState,
  switchChannel
} from './drawer.js'
